// ConfigProvider.js
import React, { createContext, useEffect, useState } from 'react';
import {
  getDefaultConfig,
  setConfig as setGlobalConfig,
  getConfig as getGlobalConfig
} from './configService';
import {Box, Typography} from "@mui/material";
import LoadingSpinner from "./components/LoadingSpinner";

export const ConfigContext = createContext(getDefaultConfig());

export function ConfigProvider({ children }) {
  // Initialize with `null` so we know we’re waiting for fetch
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch('/config/config.json')
      .then((response) => {
        if (!response.ok) {
          // e.g., 404 => no config file in local dev or missing config in K8s
          throw new Error(`Failed to load config.json: ${response.status}`);
        }
        return response.json();
      })
      .then((fetchedConfig) => {
        // Overwrite local state & global store
        setConfig(fetchedConfig);
        setGlobalConfig(fetchedConfig);
      })
      .catch((err) => {
        // If fetch fails (or no config file exists), log & revert to default
        console.error("Config fetch failed. Using default.", err);
        setConfig(getDefaultConfig());
        setGlobalConfig(getDefaultConfig());
      });
  }, []);

  // If `config` is still `null`, don’t render children yet
  if (!config) {
    return <Box height={"100vh"} width={"100vw"} style={{alignContent: "space-around"}} >
      <LoadingSpinner statusMessage={"Loading Configuration"} />
    </Box>;
  }

  // Once config is set, provide it
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
}
